import React, { useState, useEffect } from "react";
import { EventBus } from "./eventBus";

interface UserData {
  username: string;
  userId: string;
  token: string;
}

interface UserInfoProps {
  initialUserInfo?: UserData;
  title?: string;
  showUpdateButton?: boolean;
}

const generateRandomUser = (): UserData => {
  const names = ["张三", "李四", "王五", "赵六", "钱七", "孙八", "周九", "吴十"];
  const randomName = names[Math.floor(Math.random() * names.length)];
  const randomId = Math.floor(Math.random() * 1000000).toString();
  const randomToken = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  return {
    username: randomName,
    userId: randomId,
    token: randomToken,
  };
};

const UserInfo: React.FC<UserInfoProps> = ({ 
  initialUserInfo, 
  title = "Host 用户信息",
  showUpdateButton = true 
}) => {
  const isHost = showUpdateButton;
  const [userInfo, setUserInfo] = useState<UserData>(() => {
    if (isHost) {
      return initialUserInfo || generateRandomUser();
    }
    return initialUserInfo || { username: "", userId: "", token: "" };
  });

  useEffect(() => {
    if (isHost) {
      EventBus.emit("user-info-update", userInfo);
    }
  }, [userInfo, isHost]);

  useEffect(() => {
    if (isHost) return;

    const handleUserInfoUpdate = (data: UserData) => {
      if (data && data.username && data.userId && data.token) {
        setUserInfo(data);
      }
    };

    EventBus.on("user-info-update", handleUserInfoUpdate);
    EventBus.emit("request-user-info");

    return () => {
      EventBus.off("user-info-update", handleUserInfoUpdate);
    };
  }, [isHost]);

  useEffect(() => {
    if (!isHost) return;

    const handleUpdateRequest = () => {
      const newUserInfo = generateRandomUser();
      setUserInfo(newUserInfo);
    };

    EventBus.on("update-user-info-request", handleUpdateRequest);

    return () => {
      EventBus.off("update-user-info-request", handleUpdateRequest);
    };
  }, [isHost]);

  useEffect(() => {
    if (!isHost) return;

    const handleRequestUserInfo = () => {
      EventBus.emit("user-info-update", userInfo);
    };

    EventBus.on("request-user-info", handleRequestUserInfo);

    return () => {
      EventBus.off("request-user-info", handleRequestUserInfo);
    };
  }, [userInfo, isHost]);

  const handleUpdate = () => {
    const newUserInfo = generateRandomUser();
    setUserInfo(newUserInfo);
  };

  return (
    <div className="glass-card" style={{ padding: "16px", marginBottom: "20px" }}>
      <div className="text-primary" style={{ marginBottom: "12px", marginTop: 0, marginLeft: 0, marginRight: 0, fontWeight: "600" }}>
        {title}
      </div>
      <div style={{ fontSize: "14px", display: "grid", gridTemplateColumns: "auto 1fr", gap: "8px 16px" }}>
        <div className="text-secondary" style={{ fontWeight: "bold" }}>用户名：</div>
        <div className="text-primary">{userInfo.username}</div>
        <div className="text-secondary" style={{ fontWeight: "bold" }}>用户ID：</div>
        <div className="text-primary">{userInfo.userId}</div>
        <div className="text-secondary" style={{ fontWeight: "bold" }}>Token：</div>
        <div className="text-muted" style={{ wordBreak: "break-all", fontFamily: "monospace", fontSize: "12px" }}>{userInfo.token}</div>
      </div>
      {showUpdateButton && (
        <div style={{ marginTop: "12px" }}>
          <button onClick={handleUpdate} className="btn-primary">
            更新用户信息
          </button>
        </div>
      )}
    </div>
  );
};

export default UserInfo;



